import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import TimeSlotService from "src/service/timeslot";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Update Time Slot ",
  },
];

const validationSchema = yup.object({
  shift_name: yup
    .string("Shift Name")
    .min(2, "Shift Name should be of minimum 2 characters in length")
    .max(30, "Shift Name should be of maximum 30 characters in length")
    .required("Shift Name is required"),
  from_time: yup.string("plan to_time").required("paln to_time is required"),
  to_time: yup.string("plan charge").required("paln charge is required"),
});

const UpdateTimeSlotList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    shift_name: "",
    from_time: "",
    to_time: "",
    charge: "",
    d_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetch_time_slot = async () => {
      try {
        const res = await TimeSlotService.get_slot_data({
          id: param.id,
        });

        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          shift_name: res.data[0].shift_name,
          from_time: res.data[0].from_time,
          to_time: res.data[0].to_time,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetch_time_slot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param.id]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await TimeSlotService.update_slot_data(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/timeslot");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title=" Update Time Slot " items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Time Slot
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/timeslot");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={4} md={6} sm={6} xs={12} mt={2}>
              <CustomFormLabel htmlFor="shift_name">
                Shift Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="shift_name"
                name="shift_name"
                type="text"
                value={values.shift_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.shift_name && Boolean(errors.shift_name)}
                helperText={touched.shift_name && errors.shift_name}
                variant="outlined"
                placeholder="Enter shift name"
                fullWidth
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12} mt={2}>
              <CustomFormLabel htmlFor="from_time">
                From Time <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="from_time"
                name="from_time"
                type="time"
                value={values.from_time}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.from_time && Boolean(errors.from_time)}
                helperText={touched.from_time && errors.from_time}
                variant="outlined"
                placeholder="Enter from time"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12} mt={2}>
              <CustomFormLabel htmlFor="to_time">
                To Time <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="to_time"
                name="to_time"
                type="time"
                value={values.to_time}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.to_time && Boolean(errors.to_time)}
                helperText={touched.to_time && errors.to_time}
                variant="outlined"
                placeholder="Enter to time"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            sm={12}
            xs={12}
            style={{ marginTop: "20px" }}
          >
            <Button color="primary" variant="contained" type="submit">
              Submit
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateTimeSlotList;
